/**
 * Utilita theme font definitions
 */
import type { FontsTheme } from '../../themes/ThemeTypes';

import colors from './colors';

// Create a single fonts object that matches the FontsTheme interface
const fonts: FontsTheme = {
  // Main font family
  primaryFont: "'Poppins', sans-serif",

  // Font weights
  fontWeights: {
    light: 200,
    semilight: 300,
    book: 400,
    normal: 400,
    medium: 500,
    demi: 600,
    semibold: 700,
    bold: 800,
  },

  // Font sizes
  fontSizes: {
    sm: '12px',
  },

  // Line heights (generally smaller than loop theme)
  lineHeights: {
    xs: '0.4',
    sm: '0.6',
    md: '0.8',
    lg: '1',
    xl: '1.2',
    xxl: '1.4',
    xxxl: '1.6',
  },

  // Text emphasis
  textEmphasis: {
    em: {
      fontWeight: 800,
      color: colors.primary,
    },
  },
};

export default fonts;
